/**
 * BrowsePage Component
 */

import './styles.scss';

import * as React from 'react';
import { Helmet } from 'react-helmet';

import withLicenseBar from '../../../../containers/withLicenseBar';
import SectionTemplate from '../../../templates/Section';

// Page Path
export const BrowsePagePath = '/browse';

class BrowsePage extends React.Component {
  render() {
    return (
      <SectionTemplate id="browse">
        <Helmet>
          <title>Find &amp; License Music</title>
        </Helmet>
        {this.props.children}
      </SectionTemplate>
    );
  }
}

export default withLicenseBar(BrowsePage);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/browse/Browse/index.tsx